module.exports = __webpack_public_path__ + "img/aboutUs_banner_mobile.85f6c7f5.jpg";